import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material"
import { BaseGraphTableNode } from "@store/services/converter/types"

const TableNodePreview = (props: { table: BaseGraphTableNode }) => {
  const headers = ["", ...props.table.columns]
  const rows = props.table.index.map((rowKey, index) => [
    rowKey,
    ...(props.table.data?.[index] ?? []),
  ])

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            {headers.map((header, i) => (
              <TableCell key={i}>{header}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((_, rowIndex) => (
            <TableRow key={rowIndex}>
              {headers.map((_, headerIndex) => (
                <TableCell key={`${rowIndex}-${headerIndex}`}>
                  {rows?.[rowIndex]?.[headerIndex]}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default TableNodePreview
